import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Layout, Avatar, Dropdown, Menu, Button, Tooltip } from "antd";
import { SettingFilled, LogoutOutlined, PrinterFilled } from '@ant-design/icons';

import "./index.less";
import api from "../../services/api";
import { useStateValue } from "../../state";
import { getEmailUsuario, getNomeEmpresa, getNomeLocal, getNomeUsuario, getStatusFilial, logout } from '../../services/auth';
import { BreadcrumbPage, BotaoAbrirChamado } from "../../components";
import { ModalEmpresaFilial } from "../modals";

export default function HeaderPage() {

    const [image, setImage] = useState(false);
    const [openModalEmpresaFilial, setOpenModalEmpresaFilial] = useState(false);
    const [{ manutencao }, dispatch] = useStateValue();

    const menuUsuario = (

        <Menu className="col-avatar text-right">
            <Menu.Divider />
            <Menu.Item key="1">
                <Button type="text">
                    <Link to="parametrosEmpresa">
                        <SettingFilled /> Configurações
                    </Link>
                </Button>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="2">
                <Button type="text">
                    <PrinterFilled /> Impressoras
                </Button>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="3">
                <Button type="text" block className="text-right" onClick={() => logout()}>
                    <LogoutOutlined /> Sair
                </Button>
            </Menu.Item>
        </Menu>

    );

    const avatar = useMemo(() => {
        return (<Avatar size="large" src={image} />);
    }, [image]);

    useEffect(() => {
        listarAvatar();
    }, []);

    function listarAvatar() {
        api.get(`Usuario/AvatarBase64/${getEmailUsuario()}`).then(
            res => {
                if (res.status == 200) {
                    var caminho_avatar = `data:${res.data.mimiType};base64,${res.data.imagem}`;
                    setImage(caminho_avatar);
                }
            }
        ).catch(
            erro => {
                console.log(erro)
            }
        )
    };


    return (

        <Layout.Header>
            <Row align="middle" justify="center" gutter={[8, 0]}>
                <Col xs={7} sm={12} md={11} lg={13} xl={16}>
                    <Row align='middle' gutter={[8, 0]}>
                        <Col xs={24} sm={24} md={9} lg={8} xl={4} className="logo-page text-center">
                            <img width="145" src={require("../../assets/logoWhite.png")} alt="Gestor Web"/>
                        </Col>
                        <Col md={15} lg={16} xl={14} className="hd-col">
                            <div className="w-100">
                                <span>
                                    Usuário: <b> {getNomeUsuario()} </b>
                                </span>
                            </div>
                            <div className="w-100">
                                <Tooltip title="Deseja Alterar a Empresa? Clique aqui!" placement="bottom" className="over">
                                    <span>
                                        Você está acessando a empresa: &nbsp;
                                    </span>
                                    <Button type="text" onClick={() => setOpenModalEmpresaFilial(true)} className="btn-overflow emp">
                                        <u>{`${getNomeEmpresa()} / ${getNomeLocal()}`}</u>
                                    </Button>
                                    {!getStatusFilial() && <span className="info-consult">LOCAL INATIVO (SOMENTE CONSULTA)</span>}
                                </Tooltip>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={17} sm={12} md={13} lg={11} xl={8} className="text-right">
                    <Row justify="end">
                        <BotaoAbrirChamado />
                        <Col>
                            <Dropdown overlay={menuUsuario} trigger={['click']} placement="bottomRight" arrow>
                                <span className="p-l-5">
                                    {avatar}
                                </span>
                            </Dropdown>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <ModalEmpresaFilial exibirModalEmpresaFilial={openModalEmpresaFilial} fecharModalEmpresaFilial={() => setOpenModalEmpresaFilial(false)} />
        </Layout.Header>

    );

}